import React, { memo } from 'react';
import { isNil } from 'ramda';
import clsx from 'clsx';

import { Text, View } from '../../Base';

const HeaderCell = ({
  header,
  subheader,
  classes,
  extraContainerClasses = [],
}) => (
  <View className={clsx([classes.container, ...extraContainerClasses])}>
    {!isNil(subheader) && (
      <Text noWrap className={classes.subheader}>
        {subheader}
      </Text>
    )}
    <Text noWrap className={classes.header}>
      {header}
    </Text>
  </View>
);

export default memo(
  HeaderCell,
  (prevProps, nextProps) =>
    prevProps.header === nextProps.header &&
    prevProps.subheader === nextProps.subheader
);
